/**
 * TransferDialog - Transfer & Conference Dialog
 */

import React, { useState } from 'react';
import CONFIG from '../../config';

function TransferDialog({ onClose, onTransfer, onConference, transferState }) {
  const [target, setTarget] = useState('');
  const [mode, setMode] = useState('blind'); // 'blind' | 'attended' | 'conference'
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!target) return;
    
    if (mode === 'conference') {
      onConference(target);
    } else {
      onTransfer(target, mode);
    }
  };
  
  return (
    <div className="cx-dialog-overlay" onClick={onClose}>
      <div className="cx-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="cx-dialog__header">
          <h3 className="cx-dialog__title">
            {mode === 'conference' ? 'Add to Conference' : 'Transfer Call'}
          </h3>
          <button className="cx-dialog__close" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <form className="cx-dialog__body" onSubmit={handleSubmit}>
          {/* Mode selector */}
          <div className="cx-dialog__tabs">
            <button
              type="button"
              className={`cx-dialog__tab ${mode === 'blind' ? 'cx-dialog__tab--active' : ''}`}
              onClick={() => setMode('blind')}
            >
              ↗️ Blind
            </button>
            {CONFIG.transfer.attendedTransferEnabled && (
              <button
                type="button"
                className={`cx-dialog__tab ${mode === 'attended' ? 'cx-dialog__tab--active' : ''}`}
                onClick={() => setMode('attended')}
              >
                ↔️ Attended
              </button>
            )}
            {CONFIG.conference.enabled && (
              <button
                type="button"
                className={`cx-dialog__tab ${mode === 'conference' ? 'cx-dialog__tab--active' : ''}`}
                onClick={() => setMode('conference')}
              >
                👥 Conference
              </button>
            )}
          </div>
          
          {/* Description */}
          <p className="cx-dialog__description">
            {mode === 'blind' && 'Transfer the call directly without speaking to the recipient first.'}
            {mode === 'attended' && 'Speak with the recipient before completing the transfer.'}
            {mode === 'conference' && 'Add a third party to create a 3-way conference call.'}
          </p>
          
          {/* Target input */}
          <div className="cx-dialog__form-group">
            <label className="cx-dialog__label">
              {mode === 'conference' ? 'Add Party' : 'Transfer To'}
            </label>
            <input
              type="tel"
              className="cx-dialog__input"
              value={target}
              onChange={(e) => setTarget(e.target.value)}
              placeholder="Extension or number"
              autoFocus
            />
          </div>
          
          {/* Speed dial / Recent (future) */}
          {CONFIG.features.speedDial && (
            <div className="cx-dialog__speed-dial">
              <span className="cx-dialog__speed-dial-label">Quick Transfer:</span>
              <div className="cx-dialog__speed-dial-buttons">
                <button type="button" onClick={() => setTarget('60001')}>
                  Support (60001)
                </button>
                <button type="button" onClick={() => setTarget('60002')}>
                  Sales (60002)
                </button>
              </div>
            </div>
          )}
        </form>
        
        <div className="cx-dialog__footer">
          <button
            type="button"
            className="cx-dialog__btn cx-dialog__btn--secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="cx-dialog__btn cx-dialog__btn--primary"
            onClick={handleSubmit}
            disabled={!target}
          >
            {mode === 'blind' && '↗️ Transfer Now'}
            {mode === 'attended' && '📞 Call First'}
            {mode === 'conference' && '👥 Add to Call'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TransferDialog;
